<template>
    <div class="modal employee-modal" :class="{ 'is-active': active }">
        <div class="modal-background"></div>
        <div class="modal-content">
            <div class="modal-sidebar">
                <figure class="thumbnail">
                    <img :src="(employee.third) ? employee.third.size.full : employee.secondary.size.full" :alt="employee.name">
                </figure>
                <div class="contacts">
                    <ul>
                        <li v-if="employee.phone">Cell: <a :href="'tel: '+employee.phone" v-text="employee.phone"></a></li>
                        <li>Email: <a :href="'mailto: '+employee.email" v-text="employee.email"></a></li>
                        <li>Skype: <a :href="'skype:'+employee.skype+'?add'" v-text="employee.skype"></a></li>
                    </ul>
                </div>
            </div>
            <div class="modal-description">
                <div class="employee-name">
                    <h2 v-text="employee.name"></h2>
                    <h4 v-text="employee.role"></h4>
                </div>
                <div class="content" v-html="employee.body"></div>
                <div class="has-text-right">
                    <button @click.prevent="close"
                            class="button is-primary is-small"
                            v-text="lang('Chiudi')"></button>
                </div>
            </div>
        </div>
        <button @click.prevent="close" class="modal-close is-large"></button>
    </div>
</template>
<script>
    export default {
        props: {
            employee: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                required: true
            }
        },
        methods: {
            close() {
                this.$emit('close')
            }
        }
    }
</script>